
import { Newspaper } from "lucide-react";

interface NoNewsAlertsProps {
  isFiltering: boolean;
}

export const NoNewsAlerts: React.FC<NoNewsAlertsProps> = ({ isFiltering }) => {
  return (
    <div className="text-center py-8">
      <Newspaper className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
      <p className="text-lg font-medium mb-2">
        {isFiltering ? 'No matching alerts found' : 'No news alerts yet'}
      </p>
      <p className="text-sm text-muted-foreground">
        {isFiltering 
          ? 'Try adjusting your search criteria or filters'
          : 'News alerts will appear here when monitoring finds relevant articles'
        }
      </p>
    </div>
  );
};
